<template>
    <div v-if="current.okxConfig.marginType == constants.CROSS">
        <el-button icon="ArrowDownBold" style="width:120px" @click="showDialog(constants.CROSS)" :loading="loading">
            <span class="bold">{{ current.okxConfig.crossLongLeverage }}</span>
            <el-icon>
                <Close />
            </el-icon>
        </el-button>
        <el-tooltip content="刷新杠杆" effect="light" placement="top">
            <el-button icon="Refresh" @click="loadLeverage(true)" :loading="loading" />
        </el-tooltip>
    </div>
    <div v-else>
        <el-button style="width:160px" @click="showDialog(constants.ISOLATED, constants.LONG)" :loading="loading">
            <div class="leverage">
                <div class="long">
                    <div class="txt">多 {{ current.okxConfig.isolatedLongLeverage }}</div>
                    <div class="icon">
                        <el-icon>
                            <Close />
                        </el-icon>
                    </div>
                </div>
                <div class="short">
                    <div class="long">空 {{ current.okxConfig.isolatedShortLeverage }}</div>
                    <div class="icon">
                        <el-icon>
                            <Close />
                        </el-icon>
                    </div>
                </div>
            </div>
        </el-button>
        <el-tooltip content="刷新杠杆" effect="light" placement="top">
            <el-button icon="Refresh" @click="loadLeverage(true)" :loading="loading" />
        </el-tooltip>
    </div>
    <el-dialog v-model="dialogVisible" title="调整杠杆" width="500" :close-on-click-modal="false" draggable>
        <!-- 全仓模式：显示一个杠杆 -->
        <template v-if="operMgnMode == constants.CROSS">
            <div class="direct">杠杆倍数</div>
            <el-row style="margin-bottom:20px">
                <el-col :span="8" class="minusbtn">
                    <el-button size="small" @click="minsCross()">-</el-button>
                </el-col>
                <el-col :span="8" style="text-align: center;" class="leverageinput">
                    <el-input v-model="leverage" size="large" :min="1" :max="125" type="number" />
                </el-col>
                <el-col :span="8" class="plusbtn">
                    <el-button size="small" @click="plusCross()">+</el-button>
                </el-col>
            </el-row>
            <el-row :gutter="10" style="margin-bottom:20px">
                <el-col :span="1"></el-col>
                <el-col :span="22">
                    <el-slider v-model="leverage" :step="5" :min="0" :max="125" show-stops></el-slider>
                </el-col>
                <el-col :span="1"></el-col>
            </el-row>
        </template>
        <!-- 逐仓模式：显示多和空两个杠杆 -->
        <template v-else>
            <div class="direct">做多</div>
            <el-row style="margin-bottom:20px">
                <el-col :span="8" class="minusbtn">
                    <el-button size="small" @click="minsLong()">-</el-button>
                </el-col>
                <el-col :span="8" style="text-align: center;" class="leverageinput">
                    <el-input class="green" v-model="leverageLong" size="large" :min="1" :max="125" type="number" />
                </el-col>
                <el-col :span="8" class="plusbtn">
                    <el-button size="small" @click="plusLong()">+</el-button>
                </el-col>
            </el-row>
            <el-row :gutter="10" style="margin-bottom:20px">
                <el-col :span="1"></el-col>
                <el-col :span="22">
                    <el-slider v-model="leverageLong" :step="5" :min="0" :max="125" show-stops
                        style="margin-bottom: 15px;">
                    </el-slider>
                </el-col>
                <el-col :span="1"></el-col>
            </el-row>
            <div class="direct">做空</div>
            <el-row style="margin-bottom:20px">
                <el-col :span="8" class="minusbtn">
                    <el-button size="small" @click="minsShort()">-</el-button>
                </el-col>
                <el-col :span="8" style="text-align: center;" class="leverageinput">
                    <el-input class="red" v-model="leverageShort" size="large" :min="1" :max="125" type="number" />
                </el-col>
                <el-col :span="8" class="plusbtn">
                    <el-button size="small" @click="plusShort()">+</el-button>
                </el-col>
            </el-row>
            <el-row :gutter="10" style="margin-bottom:20px">
                <el-col :span="1"></el-col>
                <el-col :span="22">
                    <el-slider v-model="leverageShort" :step="5" :min="0" :max="125" show-stops>
                    </el-slider>
                </el-col>
                <el-col :span="1"></el-col>
            </el-row>
        </template>
        <template #footer>
            <div class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submit()" :loading="loadingSave">保 存</el-button>
            </div>
        </template>
    </el-dialog>
</template>
<style scoped>
.leverageinput>>>input {
    text-align: center !important;
    font-size: 36px;
}

.leverageinput>>>input::-webkit-outer-spin-button,
.leverageinput>>>input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.leverageinput>>>input[type=number] {
    -moz-appearance: textfield;
}

.leverageinput>>>.el-input__wrapper {
    background-color: none;
    box-shadow: none;
}

.direct {
    text-align: center;
    font-size: 14px;
    margin-bottom: 10px;
}

.leverage {
    display: flex;
    width: 100px;
}

.leverage .long {
    flex: 1;
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.leverage .short {
    flex: 1;
    text-align: center;
    display: flex;
    flex-direction: row;
    align-items: center;
}

.txt {
    flex: 1;
}

.icon {
    flex: 1;
    padding-top: 5px;
}

.plusbtn {
    text-align: left;
    padding-top: 7px;
}

.minusbtn {
    text-align: right;
    padding-top: 7px;
}

.green>>>.el-input__inner {
    color: #67c23a !important;
}

.red>>>.el-input__inner {
    color: #f56c6c !important;
}
</style>
<script setup>
import { ref, toRaw, onMounted, watch } from 'vue'
import { ElMessage } from 'element-plus'
import * as constants from '@/utils/okxConstants'
import { useSystemStore } from '@/stores/system'
import { useLogStore } from '@/stores/log'

const systemStore = useSystemStore()
const logStore = useLogStore()
const current = ref(systemStore.currentusymbol)
const dialogVisible = ref(false)
const loading = ref(false)
const loadingSave = ref(false)
const leverage = ref(0)
const leverageLong = ref(0)
const leverageShort = ref(0)
const lastValidLeverage = ref(1)
const lastValidLeverageLong = ref(1)
const lastValidLeverageShort = ref(1)
const operMgnMode = ref("")
const operPosSide = ref("")

onMounted(() => {
    loadLeverage(false)
})

// 监听 `currentusymbol` 变化
watch(() => systemStore.changeUsymbol, () => {
    loadLeverage(false)
})

// 监听 leverage 变化，确保只能输入 1-125 的整数
watch(leverage, (newVal) => {
    let num = parseInt(newVal)
    if (isNaN(num) || num < 1 || num > 125) {
        leverage.value = lastValidLeverage.value
    } else {
        leverage.value = num
        lastValidLeverage.value = num
    }
})

// 监听 leverageLong 变化
watch(leverageLong, (newVal) => {
    let num = parseInt(newVal)
    if (isNaN(num) || num < 1 || num > 125) {
        leverageLong.value = lastValidLeverageLong.value
    } else {
        leverageLong.value = num
        lastValidLeverageLong.value = num
    }
})

// 监听 leverageShort 变化
watch(leverageShort, (newVal) => {
    let num = parseInt(newVal)
    if (isNaN(num) || num < 1 || num > 125) {
        leverageShort.value = lastValidLeverageShort.value
    } else {
        leverageShort.value = num
        lastValidLeverageShort.value = num
    }
})

const plusCross = () => {
    if (leverage.value < 125) {
        leverage.value += 1
        lastValidLeverage.value = leverage.value
    }
}

const minsCross = () => {
    if (leverage.value > 1) {
        leverage.value -= 1
        lastValidLeverage.value = leverage.value
    }
}

const plusLong = () => {
    if (leverageLong.value < 125) {
        leverageLong.value += 1
        lastValidLeverageLong.value = leverageLong.value
    }
}

const minsLong = () => {
    if (leverageLong.value > 1) {
        leverageLong.value -= 1
        lastValidLeverageLong.value = leverageLong.value
    }
}

const plusShort = () => {
    if (leverageShort.value < 125) {
        leverageShort.value += 1
        lastValidLeverageShort.value = leverageShort.value
    }
}

const minsShort = () => {
    if (leverageShort.value > 1) {
        leverageShort.value -= 1
        lastValidLeverageShort.value = leverageShort.value
    }
}

//type=true 强制刷新
const loadLeverage = async (type) => {
    try {
        loading.value = true

        //获取全仓杠杆
        if (type || (current.value.okxConfig.crossLongLeverage == 0 || current.value.okxConfig.crossShortLeverage == 0)) {

            let result = await systemStore.privateClient.getLeverage(current.value.symbol, constants.CROSS)
            let long = result.find(x => x.posSide == constants.LONG)
            let short = result.find(x => x.posSide == constants.SHORT)
            let _obj = {
                name: current.value.name,
                config: {
                    crossLongLeverage: long.lever,
                    crossShortLeverage: short.lever,
                    isolatedLongLeverage: current.value.okxConfig.isolatedLongLeverage,
                    isolatedShortLeverage: current.value.okxConfig.isolatedShortLeverage,
                }
            }
            systemStore.updateOkxConfig(_obj)
        }

        //获取逐仓杠杆
        if (type || (current.value.okxConfig.isolatedLongLeverage == 0 || current.value.okxConfig.isolatedShortLeverage == 0)) {
            let result = await systemStore.privateClient.getLeverage(current.value.symbol, constants.ISOLATED)
            let long = result.find(x => x.posSide == constants.LONG)
            let short = result.find(x => x.posSide == constants.SHORT)
            let _obj = {
                name: current.value.name,
                config: {
                    crossLongLeverage: current.value.okxConfig.crossLongLeverage,
                    crossShortLeverage: current.value.okxConfig.crossShortLeverage,
                    isolatedLongLeverage: long.lever,
                    isolatedShortLeverage: short.lever,
                }
            }
            systemStore.updateOkxConfig(_obj)
        }

        loading.value = false
    } catch (error) {
        ElMessage.error('获取杠杆失败' + error)
        loading.value = false
        logStore.addLog({
            title: '获取杠杆失败',
            level: 'error',
            message: error
        })
    }
}

const showDialog = (mgnMode, posSide) => {
    operMgnMode.value = mgnMode

    if (mgnMode === constants.CROSS) {
        //全仓杠杆，多空只用1个
        leverage.value = parseInt(current.value.okxConfig.crossLongLeverage)
        lastValidLeverage.value = parseInt(current.value.okxConfig.crossLongLeverage)
    } else {
        //逐仓杠杆
        leverageLong.value = parseInt(current.value.okxConfig.isolatedLongLeverage)
        lastValidLeverageLong.value = parseInt(current.value.okxConfig.isolatedLongLeverage)
        leverageShort.value = parseInt(current.value.okxConfig.isolatedShortLeverage)
        lastValidLeverageShort.value = parseInt(current.value.okxConfig.isolatedShortLeverage)
    }

    //记录当前操作类型
    operPosSide.value = posSide || ""
    dialogVisible.value = true
}

const submit = async () => {
    try {

        loadingSave.value = true
        // 全仓时两个都设为同一个值
        if (operMgnMode.value == constants.CROSS) {
            const params = [
                {
                    instId: current.value.symbol,
                    mgnMode: constants.CROSS,
                    lever: leverage.value.toString(),
                    posSide: constants.LONG
                },
                {
                    instId: current.value.symbol,
                    mgnMode: constants.CROSS,
                    lever: leverage.value.toString(),
                    posSide: constants.SHORT
                }
            ]
            await systemStore.privateClient.setLeverage(params[0])
            await systemStore.privateClient.setLeverage(params[1])
        } else {
            // 逐仓时分别设置多和空
            const params = [
                {
                    instId: current.value.symbol,
                    mgnMode: constants.ISOLATED,
                    lever: leverageLong.value.toString(),
                    posSide: constants.LONG
                },
                {
                    instId: current.value.symbol,
                    mgnMode: constants.ISOLATED,
                    lever: leverageShort.value.toString(),
                    posSide: constants.SHORT
                }
            ]
            await systemStore.privateClient.setLeverage(params[0])
            await systemStore.privateClient.setLeverage(params[1])
        }
        ElMessage.success('保存成功')

        let _crossLongLeverage = 0
        let _crossShortLeverage = 0
        let _isolatedLongLeverage = 0
        let _isolatedShortLeverage = 0

        if (operMgnMode.value == constants.CROSS) {
            _crossLongLeverage = leverage.value
            _crossShortLeverage = leverage.value
            _isolatedLongLeverage = current.value.okxConfig.isolatedLongLeverage
            _isolatedShortLeverage = current.value.okxConfig.isolatedShortLeverage
        } else {
            _crossLongLeverage = current.value.okxConfig.crossLongLeverage
            _crossShortLeverage = current.value.okxConfig.crossShortLeverage
            _isolatedLongLeverage = leverageLong.value
            _isolatedShortLeverage = leverageShort.value
        }

        //修改缓存
        let _obj = {
            name: current.value.name,
            config: {
                marginType: current.value.okxConfig.marginType,
                crossLongLeverage: _crossLongLeverage,
                crossShortLeverage: _crossShortLeverage,
                isolatedLongLeverage: _isolatedLongLeverage,
                isolatedShortLeverage: _isolatedShortLeverage,
            },
        }

        systemStore.updateOkxConfig(_obj)
        loadingSave.value = false
        dialogVisible.value = false

    } catch (error) {
        ElMessage.error('保存失败' + error)
        loadingSave.value = false
        logStore.addLog({
            title: '保存杠杆失败',
            level: 'error',
            message: error
        })
    }
}

</script>